import { formatDate } from '@collab/utils/formatters';

export type ApiApplication = {
  id: string;
  name: string;
  createdDate: string;
};

export type ApiPublishStatus = 'reviewing' | 'approved' | 'unpublished';

export type ApiApplicationUsage = {
  callsCount: number;
  limit: number;
};

export type ApiSecrets = {
  primary: string;
  secondary: string;
};

export type ApiApplicationDetails = {
  usage: ApiApplicationUsage;
  publishStatus: ApiPublishStatus;
  hasRP: boolean;
};

export type ClientCredentials = {
  clientId: string;
  clientSecret: string;
  restrictedScopes: string;
};

type ApiScope = {
  name: string;
  description: string;
};

export const normalizeApplication = (data: any): ApiApplication => ({
  id: data.id,
  name: data.displayName,
  createdDate: formatDate(data.createdDate),
});

export const normalizeApplications = (data: any): ApiApplication[] =>
  data.applications.map((c: any) => normalizeApplication(c));

export const normalizeApiSecrets = (data: any): ApiSecrets => ({
  primary: data.secrets.primaryKey,
  secondary: data.secrets.secondaryKey,
});

export const normalizeApplicationDetails = (
  data: any,
): ApiApplicationDetails => ({
  usage: {
    callsCount: data.details.usage.callsCount,
    limit: data.details.usage.limit,
  },
  publishStatus: data.details.published.status,
  hasRP: data.details.hasRP,
});

export const normalizeScopes = (data: any): ApiScope[] =>
  data.scopes.map((scope: any) => ({
    name: scope,
    description: '',
  }));
